import * as React from "react";
import { useState, useEffect } from "react";
import banner1 from "../../../assets/banner/2026_banner_2.png";
import banner2 from "../../../assets/banner/2026_banner_3.png";
import banner3 from "../../../assets/banner/2026_banner_6.png";

const images = [
  { label: "banner_image3", imgPath: banner3 },
  { label: "banner_image1", imgPath: banner1 },
  { label: "banner_image2", imgPath: banner2 },
];

function Banner() {
  const [current, setCurrent] = useState(0);

  // Auto-advance
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ position: "relative", width: "100%", overflow: "hidden" }}>
      {/* Slides */}
      <div
        style={{
          display: "flex",
          transition: "transform 0.5s ease",
          transform: `translateX(-${current * 100}%)`,
        }}
      >
        {images.map((image) => (
          <img
            key={image.label}
            src={image.imgPath}
            alt={image.label}
            style={{
              minWidth: "100%",
              height: "clamp(200px, 60vw, 130vh)",
              objectFit: "cover",
              display: "block",
            }}
          />
        ))}
      </div>

      {/* Prev / Next arrows */}
      <button
        onClick={() =>
          setCurrent((prev) => (prev - 1 + images.length) % images.length)
        }
        style={{
          position: "absolute",
          top: "50%",
          left: "16px",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.4)",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          fontSize: "18px",
          cursor: "pointer",
        }}
      >
        ‹
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % images.length)}
        style={{
          position: "absolute",
          top: "50%",
          right: "16px",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.4)",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          fontSize: "18px",
          cursor: "pointer",
        }}
      >
        ›
      </button>

      {/* Dots */}
      <div
        style={{
          position: "absolute",
          bottom: "12px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        {images.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              border: "none",
              background: i === current ? "#fff" : "rgba(255,255,255,0.5)",
              cursor: "pointer",
              padding: 0,
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default Banner;
